module.exports = __webpack_public_path__ + "static/media/chef_house_bg_1080x1920.19b15381.jpg";